module.exports = __webpack_public_path__ + "img/logo-registration.45a1f86e.svg";